import {
  GET_SINGLE_CLIENT_REPORT_DETAILS,
  SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS,
  SET_COUNT_SINGLE_CLIENT_REPORT,
  SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT,
  SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT,
  SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS,
} from "../../types";

import createAsyncActions from "../../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";

export const {
  getSingleClientReportDetails,
  getSingleClientReportDetailsPending,
  getSingleClientReportDetailsFulfilled,
  getSingleClientReportDetailsRejected,
} = createAsyncActions(
  GET_SINGLE_CLIENT_REPORT_DETAILS,
  "getSingleClientReportDetails"
);

export const toggleCollapsesClosedSingleClientReport = createAction(
  SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS
);

export const toggleAllCollapsesSingleClientReport = createAction(
  SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS
);

export const setExpandedRowsLinkedClientsSingleClientReport = createAction(
  SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT
);

export const setItemsPerPageSingleClientReport = createAction(
  SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT
);

export const setCountSingleClientReport = createAction(
  SET_COUNT_SINGLE_CLIENT_REPORT
);



// WEBPACK FOOTER //
// ./src/features/reports/actions/single-client/getSingleClientReportDetailsActions.js